// Motion preferences: keep animations for most users; provide safe fallbacks elsewhere.
export function prefersReducedMotion() {
    if (!window.matchMedia) {
        return false;
    }
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function revealMotionTargets() {
    $('.fadeIn, .slideIn').addClass('vis');
    $('.fadeInRow > div, .fadeInRow > li, .fadeInRow > p, .fadeInRow > span, .fadeInRow > h1, .fadeInRow > h2, .fadeInRow > a, .fadeInRow > .topline').addClass('vis');
}
